import React from 'react'
import styled from "styled-components"

import { Link as InternalLink } from "gatsby"

import { typeHeading02, typeHeading03, typeHeading04, typeBody02, typeLabel01 } from '../../theme/typography'
import { grid, row, column } from '../../theme/grid'
import { spacer, unit, pixelate, margin, SIZE, mediaQuery, gutter } from '../../theme/metrics'
import { WHITE_01 } from '../../theme/colors'

import { StyledButtons } from '../../theme/components'

import { button } from '../../theme/core';


export const Inner = styled.div`
	${row({medium:true})}
	margin-bottom: ${unit(-8)};

	${mediaQuery[SIZE.large]}{
		margin-bottom: ${spacer(-2)};
	}
`

export const MemberContainer = styled.div`
	${props => column({medium:{span:6},large:{span:4}},{direction:props.theme.direction})}
	margin-bottom: ${unit(8)};

	${mediaQuery[SIZE.large]}{
		margin-bottom: ${spacer(2)};
	}
`

export const MemberContent = styled.div`
	background-color: ${props => props.theme.shadow};
	padding-right: ${margin(SIZE.small)};
	margin-top: ${margin(SIZE.small)};

	${mediaQuery[SIZE.medium]}{
		padding-right: ${gutter(SIZE.medium)};
		margin-top: ${gutter(SIZE.medium)};
	}

	${mediaQuery[SIZE.large]}{
		padding-right: ${gutter(SIZE.large)};
		margin-top: ${gutter(SIZE.large)};
	}

	${mediaQuery[SIZE.xlarge]}{
		padding-right: ${gutter(SIZE.xlarge)};
		margin-top: ${gutter(SIZE.xlarge)};
	}

	${mediaQuery[SIZE.max]}{
		padding-right: ${gutter(SIZE.max)};
		margin-top: ${gutter(SIZE.max)};
	}
`

export const MemberInner = styled.div`
	position: relative;
	top: ${margin(SIZE.small,{multiplier:-1})};

	${mediaQuery[SIZE.medium]}{
		top: ${gutter(SIZE.medium,{multiplier:-1})};
	}

	${mediaQuery[SIZE.large]}{
		top: ${gutter(SIZE.large,{multiplier:-1})};
	}

	${mediaQuery[SIZE.xlarge]}{
		top: ${gutter(SIZE.xlarge,{multiplier:-1})};
	}

	${mediaQuery[SIZE.max]}{
		top: ${gutter(SIZE.max,{multiplier:-1})};
	}
`

export const MemberInfo = styled.div`
	display: flex;
	align-items: flex-end;
	padding-top: ${margin(SIZE.small)};
	padding-left: ${margin(SIZE.small)};

	${mediaQuery[SIZE.medium]}{
		padding-top: ${gutter(SIZE.medium)};
		padding-left: ${gutter(SIZE.medium)};
	}

	${mediaQuery[SIZE.large]}{
		padding-top: ${gutter(SIZE.large)};
		padding-left: ${gutter(SIZE.large)};
	}

	${mediaQuery[SIZE.xlarge]}{
		padding-top: ${gutter(SIZE.xlarge)};
		padding-left: ${gutter(SIZE.xlarge)};
	}

	${mediaQuery[SIZE.max]}{
		padding-top: ${gutter(SIZE.max)};
		padding-left: ${gutter(SIZE.max)};
	}
`

export const MemberText = styled.div`
	flex: 1;
`

export const LinkedIn = styled.a`
	display: block;
`

export const Name = styled.p`
	${typeBody02}
`

export const Role = styled.p`
	${typeLabel01}
	margin-top: ${unit(1)};
`

export const Photo = styled.img`
	width: 100%;
	height: auto;
	position: relative;
	margin-top: ${margin(SIZE.small,{multiplier:-1})};

	${mediaQuery[SIZE.medium]}{
		margin-top: ${gutter(SIZE.medium,{multiplier:-1})};
	}

	${mediaQuery[SIZE.large]}{
		margin-top: ${gutter(SIZE.large,{multiplier:-1})};
	}

	${mediaQuery[SIZE.max]}{
		margin-top: ${gutter(SIZE.max,{multiplier:-1})};
	}
`